export default {
    "lyrics": [
        {
            "characters": ["greg"],
            "time": "00:20",
            "lyric": "Ooh!"
        },
        {
            "characters": ["greg"],
            "time": "00:23",
            "lyric": "First, I'd like to formally thank my friends in the VC community"
        },
        {
            "characters": ["greg"],
            "time": "00:26",
            "lyric": "For all they've done for me"
        },
        {
            "characters": ["greg"],
            "time": "00:27",
            "lyric": "For all of this diligent disunity"
        },
        {
            "characters": ["greg"],
            "time": "00:29",
            "lyric": "I told you we've got ample liquidity to support our clients"
        },
        {
            "characters": ["greg"],
            "time": "00:31",
            "lyric": "With one exception"
        },
        {
            "characters": ["greg"],
            "time": "00:33",
            "lyric": "If everyone is telling everyone we're in trouble"
        },
        {
            "characters": ["greg"],
            "time": "00:34",
            "lyric": "We'll get to a misconception"
        },
        {
            "characters": ["greg"],
            "time": "00:35",
            "lyric": "Just as if we went on a date like"
        },
        {
            "characters": ["greg"],
            "time": "00:36",
            "lyric": "We sat on a theater, and the movie is fine"
        },
        {
            "characters": ["greg"],
            "time": "00:37",
            "lyric": "And you yell that the theater is on fire"
        },
        {
            "characters": ["greg"],
            "time": "00:38",
            "lyric": "You go with the frenzy and run over me with snow tires"
        },
        {
            "characters": ["greg"],
            "time": "00:40",
            "lyric": "After I poured my soul to you for 40 years"
        },
        {
            "characters": ["greg"],
            "time": "00:42",
            "lyric": 'If you asked me to jump, I\'d say "How high?"'
        },
        {
            "characters": ["greg"],
            "time": "00:46",
            "lyric": "I take you to dinner on a Wednesday"
        },
        {
            "characters": ["greg"],
            "time": "00:49",
            "lyric": "You throw me under the bus on a Thursday"
        },
        {
            "characters": ["greg"],
            "time": "00:51",
            "lyric": 'There was never "us" (2x)'
        },
        {
            "characters": ["greg"],
            "time": "00:54",
            "lyric": "Now you want to part ways"
        },
        {
            "characters": ["greg"],
            "time": "00:56",
            "lyric": "I take you to dinner on a Wednesday"
        },
        {
            "characters": ["greg"],
            "time": "01:00",
            "lyric": "You throw me under the bus on a Thursday"
        },
        {
            "characters": ["greg"],
            "time": "01:03",
            "lyric": 'There was never "us" (2x)'
        },
        {
            "characters": ["greg"],
            "time": "01:05",
            "lyric": "Now you want to part ways"
        },
        {
            "characters": ["greg"],
            "time": "01:13",
            "lyric": "Second, why did you do this?"
        },
        {
            "characters": ["greg"],
            "time": "01:14",
            "lyric": "Did you hit your head in your kitchen calacata?"
        },
        {
            "characters": ["greg"],
            "time": "01:15",
            "lyric": "Are you drunk? Or is it jet lag coming from a Caribbean Island?"
        },
        {
            "characters": ["vc"],
            "time": "01:16",
            "lyric": "😨"
        },
        {
            "characters": ["greg"],
            "time": "01:19",
            "lyric": "While we're trying to change the world"
        },
        {
            "characters": ["greg"],
            "time": "01:20",
            "lyric": "Bond by bond. Dollar by dollar"
        },
        {
            "characters": ["greg"],
            "time": "01:21",
            "lyric": "You're looking for dice to play dungeons & dragons. Dude, c'mon brother."
        },
        {
            "characters": ["vc"],
            "time": "01:22",
            "lyric": "😶"
        },
        {
            "characters": ["greg"],
            "time": "01:25",
            "lyric": "Oh, wait a sec"
        },
        {
            "characters": ["greg"],
            "time": "01:26", 
            "lyric": "While you drink Prosecco"
        },
        {
            "characters": ["greg"],
            "time": "01:27",
            "lyric": "I got people on my neck draining my bank at rate of $500K per second"
        },
        {
            "characters": ["greg"],
            "time": "01:29",
            "lyric": "Oh you thought this was my chorus?"
        },
        {
            "characters": ["vc"],
            "time": "01:30",
            "lyric": "-"
        },
        {
            "characters": ["greg"],
            "time": "01:31",
            "lyric": "Yippee ki-yay, Mr. Zucker. Maybe call us"
        },
        {
            "characters": ["greg"],
            "time": "01:35",
            "lyric": "Matt 26 much? Pressing the gas and forgetting the clutch"
        },
        {
            "characters": ["greg"],
            "time": "01:36",
            "lyric": "I can see 3rd degree oversees"
        },
        {
            "characters": ["greg"],
            "time": "01:37",
            "lyric": "Starts with FD and ends with IC"
        },
        {
            "characters": ["greg"],
            "time": "01:38",
            "lyric": "You see, from here I can see FDIC(k)'s fine toothcomb loomin' I be"
        },
        {
            "characters": ["greg"],
            "time": "01:40",
            "lyric": "I be"
        },
        {
            "characters": ["greg"],
            "time": "01:41",
            "lyric": "Flipping off. Flipping your portfolio"
        },
        {
            "characters": ["greg"],
            "time": "01:43",
            "lyric": "And at a very alarming rate, I see some people that can benefit from my expiration date"
        },
        {
            "characters": ["greg"],
            "time": "01:47",
            "lyric": "Finally, I'm tired of being your piggy bank"
        },
        {
            "characters": ["greg"],
            "time": "01:53",
            "lyric": "Next time. Next time go to your cashback neobanks"
        },
        {
            "characters": ["greg"],
            "time": "01:59",
            "lyric": "Hey no offense"
        },
        {
            "characters": ["greg"],
            "time": "02:01",
            "lyric": "But talk about a good investment huh?"
        },
        {
            "characters": ["greg"],
            "time": "02:03",
            "lyric": "Talk about a good investment"
        },
        {
            "characters": ["greg"],
            "time": "02:08",
            "lyric": "I've got nothing to do, so one more time:"
        },
        {
            "characters": ["greg"],
            "time": "02:10",
            "lyric": "I take you to dinner on a Wednesday"
        },
        {
            "characters": ["greg"],
            "time": "02:12",
            "lyric": "You throw me under the bus on a Thursday"
        },
        {
            "characters": ["greg"],
            "time": "02:16",
            "lyric": 'There was never "us" (2x)'
        },
        {
            "characters": ["greg"],
            "time": "02:18",
            "lyric": "Now you want to part ways"
        },
        {
            "characters": ["greg"],
            "time": "02:22",
            "lyric": "I take you to dinner on a Wednesday"
        },
        {
            "characters": ["greg"],
            "time": "02:23",
            "lyric": "You throw me under the bus on a Thursday"
        },
        {
            "characters": ["greg"],
            "time": "02:27",
            "lyric": 'There was never "us" (2x)'
        },
        {
            "characters": ["greg"],
            "time": "02:30",
            "lyric": "Now you want to part ways"
        },
    ]
}
